import { gql } from "@apollo/client";

export const GetAllImages = gql`
  query getAllImageGallery {
    getAllImageGallery {
      id
      imageName
      imageUrl
      imageKey
    }
  }
`;

export const DeleteImageMutation = gql`
  mutation deleteImageGallery($imageKey: String!) {
    deleteImageGallery(imageKey: $imageKey) {
      message
    }
  }
`;
